import * as React from "react";
import { Path, G, ClipPath, Defs, Rect, Mask } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const MOIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="MO" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#1C9975"
        fillRule="evenodd"
        d="M0 0v12h16V0H0Z"
        clipRule="evenodd"
      />
      <Mask
        id="b"
        width={16}
        height={12}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <Path
          fill="#fff"
          fillRule="evenodd"
          d="M0 0v12h16V0H0Z"
          clipRule="evenodd"
        />
      </Mask>
      <G mask="url(#b)">
        <Path
          fill="#FECA00"
          fillRule="evenodd"
          d="m8.01 3.427-.816.493.186-.962-.68-.72.921-.04.39-.898.39.899h.92l-.68.759.205.962-.835-.493ZM5.691 3.792l-.505.305.115-.595-.42-.445.57-.024.24-.556.241.556h.569l-.42.47.127.594-.517-.305ZM10.29 3.792l-.504.305.115-.595-.42-.445.569-.024.24-.556.242.556h.568l-.42.47.127.594-.516-.305ZM4.383 4.805l-.405.245.092-.477-.337-.358.457-.02.193-.445.194.446h.456l-.337.377.102.477-.415-.245ZM11.78 4.805l-.405.245.092-.477-.337-.358.457-.02.193-.445.194.446h.456l-.337.377.102.477-.415-.245Z"
          clipRule="evenodd"
        />
        <Mask
          id="c"
          width={8}
          height={8}
          x={4}
          y={3}
          maskUnits="userSpaceOnUse"
          style={{
            maskType: "luminance",
          }}
        >
          <Path
            fill="#fff"
            fillRule="evenodd"
            d="M8 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z"
            clipRule="evenodd"
          />
        </Mask>
        <G fill="#F7FCFF" mask="url(#c)">
          <Path
            fillRule="evenodd"
            d="M6.34 10.532h3.32v.536H6.34v-.536ZM4.979 9.73h6.383v.492H4.979V9.73Z"
            clipRule="evenodd"
          />
          <Path d="M6.31 9.51H4.358v-.5h1.949c.69-.01 1.194-.207 1.531-.586l.168-.189.187.17c.45.407.899.605 1.353.605h2.152v.5H9.546c-.522 0-1.026-.196-1.508-.58-.426.378-1.006.57-1.728.58Z" />
        </G>
        <Path
          fill="#F7FCFF"
          d="M8.017 3.804s.89.781.891 2.002c0 .192-.025.373-.062.542.213-.567.212-1.177-.005-1.838l.323-.106c.266.807.238 1.56-.078 2.252.538-.419 1.18-.671 1.922-.753l.038.338a3.959 3.959 0 0 0-.55.101c.78.005 1.396.332 1.406.338 0 0-.487 1.08-1.654 1.437a2.59 2.59 0 0 1-.907.105c.2.068.404.102.613.102.565 0 1.09-.231 1.583-.7l.235.246c-.553.528-1.161.794-1.818.794-.531 0-1.2-.313-1.737-.728a2.382 2.382 0 0 1-.159-.08l.018-.03-.022-.02a2.132 2.132 0 0 1-.153.1c-.544.503-1.138.758-1.78.758-.656 0-1.265-.266-1.818-.794l.236-.247c.492.47 1.018.701 1.583.701h.015a2.574 2.574 0 0 1-.181-.024C4.776 8.1 4.164 6.738 4.158 6.725c0 0 1.061-.391 2.143-.115.113.029.222.066.326.107a3.755 3.755 0 0 0-1.437-.476l.037-.338a4.105 4.105 0 0 1 1.654.566c-.24-.64-.24-1.33.003-2.065l.323.106c-.238.724-.218 1.387.06 1.998a2.533 2.533 0 0 1-.104-.702c0-1.154.848-1.996.854-2.002Zm.372 3.572-.052.076.064-.077-.012.001Zm-.823-.078c.05.043.095.086.138.127a3.56 3.56 0 0 1-.103-.16l-.035.033Z"
        />
      </G>
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
